
<div class="overlay-container" >
</div> 
<div class="modal show" id="myModal" >
 <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">
        <!-- <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
        <div id="addorUpdat" class="mt-4 mb-4">Choose Your Plate</div> -->
          
            <div class="row no-margin">
                <div class="col-12 col-sm-12 mb-3" [innerHTML]="message">
                  
                   <!-- Your shopping cart has not been submitted for processing.  The information about this shopping cart will be lost if you go to the Home page now.  Are you sure you want to go to the Home page? -->
                </div>
                  
                
              
                  
                        
                        <div class="col-12 col-sm-12 mb-3 confirmBoxButtonContainer">
                            <a>
                                <button class="btn btn-primary btn-commonbtn m-auto" (click)="close()">Yes </button>

                            </a>
                             <a>
                                <button class="btn btn-primary btn-commonbtn m-auto"  (click)="remove()" >No </button>
                            </a>
                     </div> 
                     
              </div>          
        </div>

    </div>
  </div>
</div>